import { PAIS } from 'src/config'

const thirdPartyLoaders = {
	abtasty: () => import('./abtasty').then((mod) => mod.loadABTasy()),
	connectif: () => import('./connectif').then((mod) => mod.loadConnectif()),
	cookiepro: () => import('./cookiepro').then((mod) => mod.loadCookiePro()),
	einstein: () => import('./einstein').then((mod) => mod.loadEinstein()),
	gtm: () => import('./gtm').then((mod) => mod.initGTM()),
	indigitall: () => import('./indigitall').then((mod) => mod.loadIndigitall()),
	salesforce: () => import('./salesforce').then((mod) => mod.loadSalesforce()),
	chatactiva: () => import('./chatActiva').then((mod) => mod.loadChatActiva())
} as const

type ThirdPartyKey = keyof typeof thirdPartyLoaders

export async function loadThirdPartyScripts() {
	// if (import.meta.env.DEV) return
	if (location.pathname.startsWith('/politicasticket')) return

	const excluded = excludedThirdPartys()
	const availableKeys = Object.keys(thirdPartyLoaders) as ThirdPartyKey[]

	const shouldLoad = (key: ThirdPartyKey): boolean => {
		if (excluded === 'all') return false
		return !excluded.has(key)
	}

	const included = availableKeys.filter(shouldLoad)

	console.log('exclude_tp options', [...availableKeys, 'all'])

	const tasks: Promise<void>[] = []

	for (const key of included) {
		if (key === 'cookiepro' && location.hostname.startsWith('pre-')) continue
		if (key === 'connectif' && PAIS !== 'Spain') continue
		if (thirdPartyLoaders[key]) {
			tasks.push(thirdPartyLoaders[key]())
		}
	}

	await Promise.all(tasks)
}

function excludedThirdPartys(): Set<string> | 'all' {
	//@ts-ignore
	const q = window.__preloadedStores__.page.query.exclude_tp
	if (!q) return new Set()
	if (q === 'all') return 'all'
	return new Set(q.split(','))
}
